import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { ISalons, ISalonsListItem } from "@/entity/salons/salons.types"
import { PaginationRequestType } from "@/entity/common/pagination.types"
import { SalonGeneralRequestType } from "@/form/salonGeneral/salonGeneral.types"
import { ResponseDataType } from "@/form/form.types"
import { prepareFormData } from '@/store/utils/formDataHelper'
import { IStoreReady } from '@/store/lib/storeSupport'

//import { createLogger } from "vuex"
@Module({   
    namespaced: true,
    name: 'salons',
    store,
    dynamic: true,
})
class SalonsModule extends VuexModule implements IStoreReady {
    salons: ISalons | null = null;
    salon: ISalonsListItem | null = null;
    ready = false
    salonLoaded = false;
    salonsLoaded = false;



    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ salons: ISalons; salonsLoaded: boolean }> {
       let salonsLoaded = false;
        const salons = await store.$repository.salons.fetchAll(prepareFormData(data));
        if (salons) {
            salonsLoaded = true;
        }
        return { salons, salonsLoaded};
    }
    @MutationAction
    async customFetchData(source:number[]):Promise<{ salons: ISalons; salonsLoaded: boolean }> {
        let salonsLoaded = false;
        const salons = await store.$repository.salons.customFetchData(source);
        if (salons) {
            salonsLoaded = true;
        }
        return { salons, salonsLoaded};
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ISalonsListItem  ; salonLoaded: boolean }> {
        let salonLoaded = false;
        const salon = await store.$repository.salons.fetchData(data);
        if (salon) {
            salonLoaded = true;
        }
        return { salon, salonLoaded};
    }
    @Action({rawError: true})
    async create(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.salons.create(data);
    }
    @Action({rawError: true})
    async update(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.salons.update(data)
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return  await store.$repository.salons.delete(data)
    }
    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }


    /*@Action
    setFilter (filter:any):any {
        console.log('filter -'+filter)
    }
    @MutationAction
    getFilter ():any {
        return warehouse.state.filters
    }*/

}

export const SalonsStore = getModule(SalonsModule);
